import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Information")
  ])
], -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_First_Name_Label",
  for: "referral-first-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0040"),
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_9 = { class: "form-group col-4 col-lg-6 pe-lg-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "referral-middle-initial" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0040"),
  /*#__PURE__*/_createTextVNode(" M.I. ")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Last_Name_Label",
  for: "referral-last-name"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0040"),
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Gender_Label",
  for: "referral-gender"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "A0810"),
  /*#__PURE__*/_createTextVNode(" Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Sex", -1 /* HOISTED */)
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_19 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "date-of-birth" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0066"),
  /*#__PURE__*/_createTextVNode(" Date of Birth "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "input-group date datepickerInput" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_25 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "referral-social-security-number" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0064"),
  /*#__PURE__*/_createTextVNode(" Social Security Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_27 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "input-group-prepend flex" }
const _hoisted_31 = { class: "input-group-text form-check mb-0 rounded-0 py-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-2",
  for: "referral-ssn-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, " Unknown ")
], -1 /* HOISTED */)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_35 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_36 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "referral-marital-status" }, " Marital Status ", -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Marital Status", -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Marital Status", -1 /* HOISTED */)
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "col-12 py-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Contact Information")
  ])
], -1 /* HOISTED */)
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_45 = { for: "referral-mobile-number" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Mobile Phone ")
const _hoisted_47 = { class: "fas fa-question-circle" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_49 = ["value"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_52 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_53 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-phone" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "referral-email" }, " Email ", -1 /* HOISTED */)
const _hoisted_58 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_Agency_Branch_Label",
  for: "agency-location-id"
}, [
  /*#__PURE__*/_createTextVNode(" Agency Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_61 = ["value"]
const _hoisted_62 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_63 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_64 = { class: "col-12 py-2" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Primary Address")
  ])
], -1 /* HOISTED */)
const _hoisted_66 = { class: "row col-12" }
const _hoisted_67 = { class: "col-12 py-2" }
const _hoisted_68 = {
  key: 0,
  class: "w-100"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label cursor-pointer btn btn-xs btn-primary",
  for: "visit-btn"
}, "+ ADD VISIT ADDRESS", -1 /* HOISTED */)
const _hoisted_70 = { class: "w-90" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 float-start" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Visit Address")
], -1 /* HOISTED */)
const _hoisted_72 = { class: "mb-2 text-end" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label cursor-pointer",
  for: "visit-btn"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" })
], -1 /* HOISTED */)
const _hoisted_74 = { class: "row col-12" }
const _hoisted_75 = { class: "col-12 py-2" }
const _hoisted_76 = { class: "w-100" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Patient Mailing Address")
], -1 /* HOISTED */)
const _hoisted_78 = { class: "form-check custom-checkbox form-check-inline mb-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sameprimarytomailing"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Primary Address")
], -1 /* HOISTED */)
const _hoisted_80 = { class: "row col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Demographic Information",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.referral?.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_First_Name",
                  name: "referral-first-name",
                  class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.FirstName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter First Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Referral.FirstName) = $event)),
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.FirstName.$touch && _ctx.v$.referral.Referral.FirstName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.Referral.FirstName]
                ]),
                (_ctx.v$.referral.Referral.FirstName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Firstname is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-middle-initial",
                  class: "form-control",
                  maxlength: "1",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.Referral.MiddleInitial) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Referral.MiddleInitial]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_Last_Name",
                  name: "referral-last-name",
                  class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.LastName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  placeholder: "Enter Last Name",
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Referral.LastName) = $event)),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.LastName.$touch && _ctx.v$.referral.Referral.LastName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.referral.Referral.LastName]
                ]),
                (_ctx.v$.referral.Referral.LastName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Lastname is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Gender",
                  class: _normalizeClass(["form-select", `${!_ctx.v$.referral.Referral.Gender.$error ? '' : 'field-invalid'}`]),
                  name: "referral-gender",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Referral.Gender) = $event)),
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.Gender.$touch && _ctx.v$.referral.Referral.Gender.$touch(...args)))
                }, [
                  _hoisted_16,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.gender, (gender, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: gender.text
                    }, _toDisplayString(gender.text), 9 /* TEXT, PROPS */, _hoisted_17))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.referral.Referral.Gender]
                ]),
                (_ctx.v$.referral.Referral.Gender.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Sex is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("input", {
                        name: "Date-Of-Birth",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.DOB.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.referral.Referral.DOB),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                        autocomplete: "off",
                        onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.DOB.$touch && _ctx.v$.referral.Referral.DOB.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_22),
                      _hoisted_23,
                      (_ctx.v$.referral.Referral.DOB.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Date of Birth is required."))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        name: "referral-social-security-number",
                        maxlength: "9",
                        class: _normalizeClass(["form-control h-100", `${!_ctx.v$.referral.Referral.SSN.$error ? '' : 'field-invalid'}`]),
                        type: "text",
                        placeholder: "Enter SSN",
                        disabled: _ctx.ssnUnknown,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ssnValue) = $event)),
                        onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.SSN.$touch && _ctx.v$.referral.Referral.SSN.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_29), [
                        [_vModelText, _ctx.ssnValue],
                        [_directive_number_only]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input mb-1 ms-1",
                          id: "referral-ssn-na",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ssnUnknown) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelCheckbox, _ctx.ssnUnknown]
                        ]),
                        _hoisted_32
                      ])
                    ])
                  ])
                ]),
                (!_ctx.ssnUnknown && _ctx.v$.referral.Referral.SSN.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                      (_ctx.v$.referral.Referral.SSN.$errors[0].$message == 'Value is required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.isDuplicateSSN
                                                ? "The SSN you entered is already assigned to another patient."
                                                : "Social Security Number is required."), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "Please enter 9 digits."))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  name: "marital-status",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Referral.MaritalStatus) = $event))
                }, [
                  _hoisted_38,
                  _hoisted_39,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.maritalStatus, (status, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: status.value
                    }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_40))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, _ctx.referral.Referral.MaritalStatus]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, [
                  _hoisted_46,
                  _withDirectives(_createElementVNode("i", _hoisted_47, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, {
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`,
                                            placement: 'right'
                                        }]
                  ]),
                  _hoisted_48
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control phone-number-input", `${!_ctx.v$.referral.Referral.PhoneHome.$error ? '' : 'field-invalid'}`]),
                  value: _ctx.formatPhone(_ctx.referral.Referral.PhoneHome),
                  maxlength: "14",
                  placeholder: "Enter Number",
                  onInput: _cache[13] || (_cache[13] = (event) => _ctx.setPhoneHome(event.target.value)),
                  onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.PhoneHome.$touch && _ctx.v$.referral.Referral.PhoneHome.$touch(...args)))
                }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_49), [
                  [_directive_number_only]
                ]),
                (_ctx.v$.referral.Referral.PhoneHome.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      (_ctx.v$.referral.Referral.PhoneHome.$errors[0].$message == 'Value is required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Mobile Phone is required."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_52, "10 Digit phone is required."))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control phone-number-input",
                  value: _ctx.formatPhone(_ctx.referral.Referral.PhoneMobile),
                  maxlength: "14",
                  placeholder: "Enter Number",
                  onInput: _cache[15] || (_cache[15] = (event) => _ctx.setPhoneMobile(event.target.value))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_55), [
                  [_directive_number_only]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createElementVNode("input", {
                  name: "referral-email",
                  class: "form-control",
                  maxlength: "50",
                  type: "text",
                  placeholder: "Enter Email",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.Referral.EmailAddress) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Referral.EmailAddress]
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _withDirectives(_createElementVNode("select", {
                  id: "Referral_Agency_Branch",
                  name: "agency-location-id",
                  class: _normalizeClass(["form-select", `${!_ctx.v$.changeBranchId?.$error ? '' : 'field-invalid'}`]),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.changeBranchId) = $event)),
                  onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.changeBranchId?.$touch && _ctx.v$.changeBranchId?.$touch(...args)))
                }, [
                  _hoisted_60,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: branch.id
                    }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_61))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.changeBranchId]
                ]),
                (_ctx.v$.changeBranchId?.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, "Branch is required."))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_ReferralAddressForm, {
                referral: _ctx.referral,
                address: _ctx.addressTypes.primary,
                "account-id": _ctx.referral.accountId,
                "application-id": _ctx.referral.application,
                "address-type": 'primary',
                "show-code": true,
                "county-data": _ctx.primaryCounties,
                "fields-required": true,
                "fields-changed": _ctx.addressFieldsChanged,
                "referral-options": _ctx.referralOptions,
                "is-primary-address": true,
                "is-refer": _ctx.isRefer,
                onUpdatecountyData: _ctx.updatecountyData
              }, null, 8 /* PROPS */, ["referral", "address", "account-id", "application-id", "county-data", "fields-changed", "referral-options", "is-refer", "onUpdatecountyData"])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            (!_ctx.hasVisitAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _withDirectives(_createElementVNode("input", {
                    hidden: "",
                    class: "form-check-input",
                    type: "radio",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.hasVisitAddress) = $event)),
                    name: "visitaddrees",
                    id: "visit-btn",
                    value: true
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.hasVisitAddress]
                  ]),
                  _hoisted_69
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.hasVisitAddress)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                      _withDirectives(_createElementVNode("input", {
                        hidden: "",
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.hasVisitAddress) = $event)),
                        name: "visitaddrees",
                        id: "visit-btn",
                        value: false
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, _ctx.hasVisitAddress]
                      ]),
                      _hoisted_73
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_ReferralAddressForm, {
                      address: _ctx.addressTypes.visit,
                      "account-id": _ctx.referral.accountId,
                      "application-id": _ctx.referral.application,
                      "address-type": 'visit',
                      "county-data": _ctx.visitCounties,
                      "show-code": false,
                      "fields-changed": _ctx.addressFieldsChanged,
                      "referral-options": _ctx.referralOptions,
                      "is-refer": _ctx.isRefer,
                      onUpdatecountyData: _ctx.updatecountyData
                    }, null, 8 /* PROPS */, ["address", "account-id", "application-id", "county-data", "fields-changed", "referral-options", "is-refer", "onUpdatecountyData"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createElementVNode("div", _hoisted_78, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "sameprimarytomailing",
                  class: "form-check-input au-target",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mailingMatchPrimary) = $event)),
                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isMailingSameAsPrimaryChanged()))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.mailingMatchPrimary]
                ]),
                _hoisted_79
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_ReferralAddressForm, {
                address: _ctx.addressTypes.mailing,
                "application-id": _ctx.referral.application,
                "account-id": _ctx.referral.accountId,
                "address-type": 'mailing',
                "show-code": false,
                "county-data": _ctx.mailingCounties,
                "fields-required": true,
                "fields-changed": _ctx.addressFieldsChanged,
                "referral-options": _ctx.referralOptions,
                "is-refer": _ctx.isRefer,
                onUpdatecountyData: _ctx.updatecountyData
              }, null, 8 /* PROPS */, ["address", "application-id", "account-id", "county-data", "fields-changed", "referral-options", "is-refer", "onUpdatecountyData"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-xs btn-primary",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.validateAddress()))
              }, "Validate")
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}